// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2064":"a1754f08","2128":"260c80f3","3866":"5146c233","4834":"a1754f08","6567":"42bb05f6","6855":"2797f1ec"}[chunkId] + ".chunk.css";
};